import { Observable } from 'rxjs';
import { CuentaAbonoRequest } from '../interfaces/cuenta-abono-request';
import { CuentaAbonoResponse } from '../interfaces/cuenta-abono.response';
import { GeneralResponse } from '../interfaces/general-response';


export abstract class CuentaAbonoService {

    abstract getCuentaAbono(): Observable<CuentaAbonoResponse>;

    abstract postCuentaAbono(datosCuenta: CuentaAbonoRequest): Observable<GeneralResponse<any>>;
}
